// extracted by css-extract-rspack-plugin
export default {"cls1":"BareSearchField-cls1_zml","cls2":"BareSearchField-cls2_W9g BareSearchField-cls1_zml"};